import { useEffect, useRef } from 'react';
import { useAuth as useClerkAuth } from '@clerk/clerk-react';
import api from '../services/api';

export const useApiSetup = () => {
  const { getToken, isLoaded, isSignedIn } = useClerkAuth();
  const interceptorRef = useRef<number | null>(null);

  useEffect(() => {
    if (!isLoaded) return;

    // Remove interceptor anterior se existir
    if (interceptorRef.current !== null) {
      api.interceptors.request.eject(interceptorRef.current);
    }

    // Configura interceptor para adicionar token em todas as requisições
    const interceptor = api.interceptors.request.use(
      async (config) => {
        try {
          // Só tenta obter o token se o usuário estiver autenticado
          if (isSignedIn) {
            const token = await getToken();
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
          }
        } catch (error) {
          console.error('Error getting Clerk token:', error);
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    interceptorRef.current = interceptor;

    // Cleanup: remove o interceptor quando o componente desmonta
    return () => {
      if (interceptorRef.current !== null) {
        api.interceptors.request.eject(interceptorRef.current);
        interceptorRef.current = null;
      }
    };
  }, [getToken, isLoaded, isSignedIn]);
};

